<template>
    <el-pagination :page-size="props.pageSize" :page-count="props.totalPage" layout="prev, pager, next" v-model:current-page="currentPage" @update:current-page="currentPageChange" />
</template>

<script lang="ts" setup>
import { Action } from '@/typeDefine/CommonTypes';

const currentPage = defineModel<number>('currentPage')

const props = defineProps<{
    totalPage: number
    pageSize: number
}>()

const emit = defineEmits<{
    currentPageChange: [number]
}>()

const currentPageChange: Action<[number]> = (value: number) => {
    emit('currentPageChange',value)
}
</script>

<style lang="css" scoped></style>